import { EmailFormValues } from '../components/form/email/types';
import * as Yup from 'yup';

export const departmentOptions = {
    trade: 'Trade (shops, hotels, restaurants)',
    finance: 'Finance',
    careers: 'Careers',
    consumerCare: 'Consumer Care',
};

export const regionOptions = {
    uk: 'UK',
    eu: 'EU',
    row: 'Rest of world',
};

export const financeDepartmentOptions = {
    payable: 'Accounts payable',
    receivable: 'Accounts receivable',
};

export const jobLocationOptions = {
    london: 'London',
    manchester: 'Manchester',
    buryStEdmunds: 'Bury St Edmunds',
};

export const productTeamOptions = {
    branston: 'Branston',
    sarsons: 'Sarson’s',
    haywards: 'Haywards',
    osu: 'Osu Apple Cider Vinegar',
};

export const initialValues: EmailFormValues = {
    department: '',
    region: '',
    financeDepartment: '',
    jobLocation: '',
    productTeam: '',
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    recaptcha: null,
};

export const validationSchema = Yup.object()
    .shape({
        department: Yup.string()
            .oneOf(Object.keys(departmentOptions))
            .required('Please choose an enquiry type'),
        region: Yup.string()
            .when('department', {
                is: 'trade',
                then: Yup.string()
                    .oneOf(Object.keys(regionOptions))
                    .required('Please choose a region'),
            }),
        financeDepartment: Yup.string()
            .when('department', {
                is: 'finance',
                then: Yup.string()
                    .oneOf(Object.keys(financeDepartmentOptions))
                    .required('Please choose a finance department'),
            }),
        jobLocation: Yup.string()
            .when('department', {
                is: 'careers',
                then: Yup.string()
                    .oneOf(Object.keys(jobLocationOptions))
                    .required('Please choose a location'),
            }),
        productTeam: Yup.string()
            .when('department', {
                is: 'consumerCare',
                then: Yup.string()
                    .oneOf(Object.keys(productTeamOptions))
                    .required('Please choose a range'),
            }),
        title: Yup.string()
            .required('Please choose your title'),
        firstName: Yup.string()
            .required('Please enter your first name'),
        lastName: Yup.string()
            .required('Please enter your surname'),
        email: Yup.string()
            .required('Please enter your email address')
            .email('Please enter a valid email address'),
        message: Yup.string()
            .required('Please enter a message'),
        recaptcha: Yup.string()
            .required('Please confirm you are not a robot'),
    });
